import { Icon } from "@mui/material";
import { Link } from "react-router-dom";

import { Episode } from "../../../shared/types/Episode";

type Props = {
  nextEp: Episode;
  idSerie: number;
  params: {
    isDys: boolean;
    fontSize: number;
  };
  returnTo: string;
  onExit: () => void;
};

const FooterNextEp = (props: Props) => {
  const { nextEp, idSerie, params, returnTo, onExit } = props;
  return (
    <div className="rd-end">
      <span className="rd-end__emoji" aria-hidden="true">
        🎉
      </span>
      <h2 className="rd-end__title">Bravo, tu as terminé cet épisode !</h2>
      <p className="rd-end__text">
        La suite t'attend : <strong>Épisode {nextEp.number}</strong>
        {nextEp.name ? ` · ${nextEp.name}` : ""}
      </p>
      <Link
        className="nbk-btn nbk-btn--secondary"
        to={`/reader/${nextEp.id}/${nextEp.origStartingNode ? nextEp.origStartingNode : nextEp.startingNode}`}
        state={{ idSerie, params, episode: nextEp, returnTo }}
      >
        Lire l'épisode suivant
        <Icon aria-hidden="true">arrow_forward</Icon>
      </Link>
      <button type="button" className="rd-end__link" onClick={onExit}>
        Retour à la série
      </button>
    </div>
  );
};

export default FooterNextEp;
